import React from 'react';
import { PROD_MEDIA_SERVER } from '@osmosis/constants';

import { bgYellow } from '@osmosis/tailwind-ui/styles/background';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { Tooltip } from '@osmosis/tailwind-ui/components/tooltip/Tooltip';
import { getColor } from '@osmosis/shared/styles';
import { VideoChapter } from '@osmosis/shared/types/learndb/learnData';

type Props = {
  chapter: VideoChapter;
  duration: number;
  onClick: (start: number) => void;
};

/**
 * .
 */
const VideoChapterPoint = ({ chapter, duration, onClick }: Props) => {
  const { title, markID, start, thumb } = chapter;

  return (
    <>
      <Box
        className={`${bgYellow} bg-opacity-75 pointer-events-none absolute bottom-0 h-full w-[4px]`}
        style={{
          left: `calc(${((+start / duration) * 100).toFixed(1)}% - 2px)`,
        }}
        aria-hidden={true}
      />

      <Box
        data-testid="video-chapter-btn"
        data-tip
        data-tooltip-id={markID}
        onClick={() => onClick(+start)}
        className="cursor-pointer absolute opacity-0 h-full w-[12px] opacity-0"
        style={{
          left: `calc(${((+start / duration) * 100).toFixed(1)}% - 6px)`,
        }}
        aria-hidden={true}
      />

      <Tooltip
        id={markID}
        style={{
          backgroundColor: getColor('light', 'gray80'),
          color: getColor('light', 'textInvert'),
        }}
        aria-hidden={true}
        place="top"
        offset={52}
      >
        <Flex className="flex flex-col items-center max-w-[160px] gap-1">
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img src={`${PROD_MEDIA_SERVER}${thumb}`} width={120} />
          <P className="!text-xs text-inherit text-center">{title}</P>
        </Flex>
      </Tooltip>
    </>
  );
};

export default VideoChapterPoint;
